import { render, staticRenderFns } from "./binding.vue?vue&type=template&id=3ae610da&scoped=true&"
import script from "./binding.vue?vue&type=script&lang=js&"
export * from "./binding.vue?vue&type=script&lang=js&"
import style0 from "./binding.vue?vue&type=style&index=0&id=3ae610da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae610da",
  null
  
)

export default component.exports